import { DistributionBlockTypeEnum } from '../../../Discover/Targeting/enums/distribution-block-type.enum';
import { BlockTypeModel } from '../../PageBuilder/models/block-type.model';
import { PanelFieldModel } from '../../PageBuilder/models/panel-field.model';
import { PanelFieldComponent } from '../../PageBuilder/components/FormFields/PanelField/panel-field.component';
import { RichTextDisplayElementModel } from '../../PageBuilder/models/rich-text-display-element.model';
import { CheckboxFieldModel } from '../../PageBuilder/models/checkbox-field.model';
import { CheckboxFieldComponent } from '../../PageBuilder/components/FormFields/CheckboxField/checkbox-field.component';
import { TextStyleFieldModel } from '../../PageBuilder/models/text-style-field.model';
import { CheckboxOptionModel } from '../../Forms/models/checkbox-option.model';
import { RichTextBlockComponent } from '../../PageBuilder/components/RichTextBlock/rich-text-block.component';
import { StyleTypesApiEnum } from '../../../api/styles/enum/style-types-api.enum';
import { ImageDisplayElementModel } from '../../PageBuilder/models/image-display-element.model';
import { TextFieldModel } from '../../PageBuilder/models/text-field.model';
import { TextFieldComponent } from '../../PageBuilder/components/FormFields/TextField/text-field.component';
import { TextStyleDefaultsModel } from '../../PageBuilder/models/text-style-defaults.model';
import { TextStyleFieldComponent } from '../../PageBuilder/components/TextStyleField/text-style-field.component';
import { FooterFieldModel } from '../../../Discover/Targeting/models/footer-field.model';
import { FooterFieldComponent } from '../../../Discover/Targeting/components/Distribution/FooterField/footer-field.component';
import { FooterDisplayElementModel } from './footer-display-element.model';
import { ImageSettingsFieldModel } from '../../PageBuilder/models/image-settings-field.model';
import { ImageSettingsFieldComponent } from '../../PageBuilder/components/FormFields/ImageSettingsField/image-settings-field.component';
import { ImageStyleFieldModel } from '../../PageBuilder/models/image-style-field.model';
import { ImageStyleFieldComponent } from '../../PageBuilder/components/FormFields/ImageStyleField/image-style-field.component';
import { DistributionStyleStateEnum } from '../enum/distribution-style-state.enum';
import { StyleStateEnum } from '../../PageBuilder/enums/style-state.enum';
import { DividerDisplayElementModel } from '../../PageBuilder/models/divider-display-element.model';
import { DividerStyleFieldModel } from '../../PageBuilder/models/divider-style-field.model';
import { DividerStyleFieldComponent } from '../../PageBuilder/components/FormFields/DividerField/divider-style-field.component';
import { DividerStyleDefaultsModel } from '../../PageBuilder/models/divider-style-defaults.model';
import { ButtonDisplayElementModel } from '../../PageBuilder/models/button-display-element.model';
import { LinkFieldModel } from '../../PageBuilder/models/link-field.model';
import { LinkFieldComponent } from '../../PageBuilder/components/FormFields/LinkField/link-field.component';
import { ButtonStyleFieldComponent } from '../../PageBuilder/components/FormFields/ButtonStyleField/button-style-field.component';
import { ButtonStyleDefaultsModel } from '../../PageBuilder/models/button-style-defaults.model';
import { ButtonStyleFieldModel } from '../../PageBuilder/models/button-style-field.model';
import { defaultButtonBackgroundColor, defaultButtonColor, defaultFontColor } from '../../PageBuilder/models/button-style.model';
import { PaddingModel } from '../../PageBuilder/models/padding.model';
import { LinkDisplayElementModel } from '../../PageBuilder/models/link-display-element.model';
import { LinksListFieldComponent } from '../../PageBuilder/components/FormFields/LinksListField/links-list-field.component';
import { LinksListFieldModel } from '../../PageBuilder/models/links-list-field.model';
import { LinksStyleFieldModel } from '../../PageBuilder/models/links-style-field.model';
import { LinksStyleFieldComponent } from '../../PageBuilder/components/FormFields/LinksStyleField/links-style-field.component';
import { LayoutDisplayElement } from '../../PageBuilder/models/layout-display-element.model';
import { LayoutBlockComponent } from '../../PageBuilder/components/LayoutBlock/layout-block.component';
import { LayoutStyleField } from '../../PageBuilder/models/layout-style-field.model';
import { LayoutStyleFieldComponent } from '../../PageBuilder/components/FormFields/LayoutStyleField/layout-style-field.component';
import { LayoutBlockType, layoutBlockTypes } from '../../PageBuilder/models/layout-block-type.model';
import { LayoutBlockTypesEnum } from '../../PageBuilder/models/block.model';
// eslint-disable-next-line max-len
import { ContentLibraryPanelFieldComponent } from '../../PageBuilder/components/FormFields/ContentLibraryPanelField/content-library-panel.component';
import { ContentLibraryFieldModel } from '../../../Common/PageBuilder/models/content-library-field-model';


// General styles uses this definition
export const distributionTitleBlockInnerStyleField = new TextStyleFieldModel(
    'styles',
    true,
    new TextStyleDefaultsModel(
        '24px',
        '#5e6473',
        true
    ),
    'Briefing.textStyle.title.label',
    true,
    true,
    true,
    StyleTypesApiEnum.TITLE,
    TextStyleFieldComponent,
    null,
    true,
    true,
    [
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleOne', value: DistributionStyleStateEnum.DISTRIBUTION_1 },
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleThree', value: DistributionStyleStateEnum.DISTRIBUTION_3 },
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleFour', value: DistributionStyleStateEnum.DISTRIBUTION_4 },
        { label: 'PageBuilder.formField.styles.custom', value: StyleStateEnum.CUSTOM }
    ]
);

export const distributionTitleBlockType = new BlockTypeModel (
    DistributionBlockTypeEnum.title,
    'PageBuilder.blockType.title',
    'agpr-i-headline',
    null,
    RichTextDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.blockType.title',
            '',
            [
                new TextFieldModel(
                    TextFieldComponent,
                    'text',
                    'PageBuilder.formField.titleLabel',
                    null,
                    false,
                    128
                )
            ]
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefing.styles.titleStylesSettings',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                distributionTitleBlockInnerStyleField
            ],
        )
    ]
);

// General styles uses this definition
export const distributionTextBlockInnerStyleField = new TextStyleFieldModel(
    'styles',
    true,
    new TextStyleDefaultsModel(
        '14px',
        '#292929',
        false
    ),
    'Briefing.textStyle.text.label',
    true,
    true,
    true,
    StyleTypesApiEnum.TEXT,
    TextStyleFieldComponent,
    undefined,
    true,
    true,
    [
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleOne', value: DistributionStyleStateEnum.DISTRIBUTION_1 },
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleTwo', value: DistributionStyleStateEnum.DISTRIBUTION_2 },
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleThree', value: DistributionStyleStateEnum.DISTRIBUTION_3 },
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleFour', value: DistributionStyleStateEnum.DISTRIBUTION_4 },
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleFive', value: DistributionStyleStateEnum.DISTRIBUTION_5 },
        { label: 'PageBuilder.formField.styles.custom', value: StyleStateEnum.CUSTOM }
    ]
);

export const distributionTextBlockType = new BlockTypeModel(
    DistributionBlockTypeEnum.text,
    'PageBuilder.blockType.text',
    'fa-solid fa-align-left',
    null,
    RichTextDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefing.styles.textStylesSettings',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                distributionTextBlockInnerStyleField
            ]
        )
    ],
    RichTextBlockComponent
);

export const distributionImageBlockInnerStyleField = new ImageStyleFieldModel(
    'styles',
    true,
    new TextStyleDefaultsModel(
        '14px',
        '#5e6473',
        false
    ),
    'Discover.distribution.imageTextStyle.image.label',
    true,
    true,
    true,
    StyleTypesApiEnum.IMAGE,
    ImageStyleFieldComponent,
    '',
    [
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleOne', value: DistributionStyleStateEnum.DISTRIBUTION_1 },
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleThree', value: DistributionStyleStateEnum.DISTRIBUTION_3 },
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleFour', value: DistributionStyleStateEnum.DISTRIBUTION_4 },
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleFive', value: DistributionStyleStateEnum.DISTRIBUTION_5 },
        { label: 'Briefings.formField.styles.custom', value: DistributionStyleStateEnum.CUSTOM }
    ],
    null,
    false
);

export const distributionLinkBlockInnerStyleField = new LinksStyleFieldModel(
    'styles',
    LinksStyleFieldComponent,
    'PageBuilder.formField.linkLabel',
    null,
    [
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleOne', value: DistributionStyleStateEnum.DISTRIBUTION_1 },
        { label: 'Briefings.formField.styles.custom', value: DistributionStyleStateEnum.CUSTOM }
    ],
    StyleTypesApiEnum.LINK
);

export const distributionLinkBlockType = new BlockTypeModel(
    DistributionBlockTypeEnum.link,
    'PageBuilder.blockType.links',
    'fa-regular fa-duotone fa-link',
    null,
    LinkDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.blockType.links',
            '',
            [
                new LinksListFieldModel(
                    'links',
                    [],
                    LinksListFieldComponent,
                    'PageBuilder.formField.linkLabel',
                    'PageBuilder.formField.linkDescription',
                ),
            ]
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.blockType.linksStyleSettings',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                distributionLinkBlockInnerStyleField
            ],
        )
    ]
);

export const distributionImageBlockType = new BlockTypeModel(
    DistributionBlockTypeEnum.image,
    'PageBuilder.blockType.image',
    'fa-regular fa-duotone fa-image',
    null,
    ImageDisplayElementModel,
    [
        new ContentLibraryFieldModel(
            ContentLibraryPanelFieldComponent,
            'image',
            'Briefings.fields.image.imageUpload',
            {
                description: 'PageBuilder.formField.uploadDescription',
                accepts: 'image/gif, image/jpeg, image/png',
                maxFiles: 1,
                buttonLabel: 'PageBuilder.formField.urlLabel',
                placeholder: 'PageBuilder.formField.urlLabel',
                required: false,
                defaultValue: undefined,
                validators: [(control) => {
                    const value = control.value as string;
                    if (value?.length > 1000) {
                        return { largeUrl: 'PageBuilder.formField.link.largeUrl' };
                    }
                    return null;
                }]
            }
        ),

        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Discover.distribution.fields.image.imageSettings',
            '',
            [
                new ImageSettingsFieldModel(
                    ImageSettingsFieldComponent,
                    'settings',
                    'PageBuilder.formField.uploadLabel',
                    'PageBuilder.formField.uploadDescription',
                    true,
                    false
                ),
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                distributionImageBlockInnerStyleField
            ]
        )
    ]
);

export const distributionDividerBlockInnerStyleField = new DividerStyleFieldModel(
    'styles',
    true,
    new DividerStyleDefaultsModel(
        2,
        '#C7C7C7',
        '#FFFFFF',
        new PaddingModel(0, true, 20, 0, 20 , 0)
    ),
    'PageBuilder.formField.dividerLabel',
    true,
    StyleTypesApiEnum.DIVIDER,
    DividerStyleFieldComponent,
    undefined,
    [
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleOne', value: DistributionStyleStateEnum.DISTRIBUTION_1 },
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleThree', value: DistributionStyleStateEnum.DISTRIBUTION_3 },
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleFour', value: DistributionStyleStateEnum.DISTRIBUTION_4 },
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleFive', value: DistributionStyleStateEnum.DISTRIBUTION_5 },
        { label: 'Briefings.formField.styles.custom', value: DistributionStyleStateEnum.CUSTOM }
    ]
);

export const distributionDividerBlockType = new BlockTypeModel(
    DistributionBlockTypeEnum.divider,
    'PageBuilder.blockType.divider',
    'fa-kit-duotone fa-agpr-divider',
    null,
    DividerDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.blockType.divider',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('PageBuilder.formField.updateAllBlocksOfType', ''),
                    true
                ),
                distributionDividerBlockInnerStyleField
            ]
        )
    ]
);

export const distributionButtonBlockInnerStyleField = new ButtonStyleFieldModel(
    'styles',
    new ButtonStyleDefaultsModel(
        '14px',
        defaultFontColor,
        true,
        defaultButtonColor,
        defaultButtonBackgroundColor,
        0
    ),
    'PageBuilder.formField.button.stylesHeader',
    true,
    StyleTypesApiEnum.BUTTON,
    ButtonStyleFieldComponent,
    undefined,
    [
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleOne', value: DistributionStyleStateEnum.DISTRIBUTION_1 },
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleThree', value: DistributionStyleStateEnum.DISTRIBUTION_3 },
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleFour', value: DistributionStyleStateEnum.DISTRIBUTION_4 },
        { label: 'Briefings.formField.styles.custom', value: DistributionStyleStateEnum.CUSTOM }
    ]
);

export const distributionButtonBlockType = new BlockTypeModel(
    DistributionBlockTypeEnum.button,
    'PageBuilder.blockType.button',
    'fa-kit fa-agpr-button',
    null,
    ButtonDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.formField.panelHeader.button',
            '',
            [
                new TextFieldModel(
                    TextFieldComponent,
                    'text',
                    'PageBuilder.formField.button.buttonText',
                    null,
                    false,
                    64,
                    'PageBuilder.formField.button.buttonPlaceholderText'
                ),
                new LinkFieldModel(
                    LinkFieldComponent,
                    'url',
                    'PageBuilder.formField.button.linkText',
                    null,
                    'PageBuilder.formField.button.linkPlaceholderText'
                ),
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                distributionButtonBlockInnerStyleField
            ]
        ),
    ]
);

export const distributionFooterBlockInnerStyleField = new TextStyleFieldModel(
    'styles',
    true,
    new TextStyleDefaultsModel(
        '12px',
        '#000000',
        false
    ),
    'Discover.distribution.footer.settings.footerTextStyleLabel',
    true,
    true,
    true,
    StyleTypesApiEnum.FOOTER,
    TextStyleFieldComponent,
    null,
    true,
    false,
    [
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleOne', value: DistributionStyleStateEnum.DISTRIBUTION_1 },
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleThree', value: DistributionStyleStateEnum.DISTRIBUTION_3 },
        { label: 'Discover.distribution.formField.styles.defaultAgilityStyleFour', value: DistributionStyleStateEnum.DISTRIBUTION_4 },
        { label: 'PageBuilder.formField.styles.custom', value: StyleStateEnum.CUSTOM }
    ]
);

export const distributionFooterBlockType = new BlockTypeModel(
    DistributionBlockTypeEnum.footer,
    'PageBuilder.blockType.footer',
    'does not matter never shown?',
    null,
    FooterDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Discover.distribution.footer.settings.footerHeader',
            '',
            [
                new FooterFieldModel(FooterFieldComponent),
                distributionFooterBlockInnerStyleField
            ]
        )
    ],
    RichTextBlockComponent
);

export const distributionOneColumnLayoutBlockInnerStyleField = new LayoutStyleField(LayoutStyleFieldComponent, 1);
export const distributionOneColumnLayoutBlockType = new LayoutBlockType(
    DistributionBlockTypeEnum.oneColumnLayout,
    'PageBuilder.blockType.layout.oneColumn',
    'fa-kit-duotone fa-agpr-button',
    null,
    LayoutDisplayElement,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.formField.panelHeader.oneColumnLayout',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                distributionOneColumnLayoutBlockInnerStyleField
            ]
        )
    ],
    LayoutBlockComponent,
    false,
    (blockType: BlockTypeModel) => {
        return blockType ? layoutBlockTypes.includes(blockType.key as LayoutBlockTypesEnum) : false;
    }
);

export const distributionTwoColumnLayoutBlockInnerStyleField = new LayoutStyleField(LayoutStyleFieldComponent, 2);
export const distributionTwoColumnLayoutBlockType = new LayoutBlockType(
    DistributionBlockTypeEnum.twoColumnLayout,
    'PageBuilder.blockType.layout.twoColumn',
    'fa-kit-duotone fa-agpr-button',
    null,
    LayoutDisplayElement,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.formField.panelHeader.twoColumnlayout',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                distributionTwoColumnLayoutBlockInnerStyleField
            ]
        )
    ],
    LayoutBlockComponent,
    false,
    (blockType: BlockTypeModel) => {
        return blockType ? layoutBlockTypes.includes(blockType.key as LayoutBlockTypesEnum) : false;
    }
);

export const distributionThreeColumnLayoutBlockInnerStyleField = new LayoutStyleField(LayoutStyleFieldComponent, 3);
export const distributionThreeColumnLayoutBlockType = new LayoutBlockType(
    DistributionBlockTypeEnum.threeColumnLayout,
    'PageBuilder.blockType.layout.threeColumn',
    'fa-kit-duotone fa-agpr-button',
    null,
    LayoutDisplayElement,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.formField.panelHeader.threeColumnlayout',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                distributionThreeColumnLayoutBlockInnerStyleField
            ]
        )
    ],
    LayoutBlockComponent,
    false,
    (blockType: BlockTypeModel) => {
        return blockType ? layoutBlockTypes.includes(blockType.key as LayoutBlockTypesEnum) : false;
    }
);


export const distributionBlockTypeEnumToBlockTypeMap: Map<DistributionBlockTypeEnum, BlockTypeModel> = new Map(
    [
        [DistributionBlockTypeEnum.title, distributionTitleBlockType],
        [DistributionBlockTypeEnum.text, distributionTextBlockType],
        [DistributionBlockTypeEnum.image, distributionImageBlockType],
        [DistributionBlockTypeEnum.divider, distributionDividerBlockType],
        [DistributionBlockTypeEnum.button, distributionButtonBlockType],
        [DistributionBlockTypeEnum.footer, distributionFooterBlockType],
        [DistributionBlockTypeEnum.link, distributionLinkBlockType],
        [DistributionBlockTypeEnum.oneColumnLayout, distributionOneColumnLayoutBlockType],
        [DistributionBlockTypeEnum.twoColumnLayout, distributionTwoColumnLayoutBlockType],
        [DistributionBlockTypeEnum.threeColumnLayout, distributionThreeColumnLayoutBlockType]
    ]
);


export const distributionsBlockTypes: BlockTypeModel[] = [
    distributionTitleBlockType,
    distributionTextBlockType,
    distributionImageBlockType,
    distributionDividerBlockType,
    distributionButtonBlockType,
    distributionLinkBlockType,
    distributionFooterBlockType
];

export const distributionLayoutBlockTypes: BlockTypeModel[] = [
    distributionOneColumnLayoutBlockType,
    distributionTwoColumnLayoutBlockType,
    distributionThreeColumnLayoutBlockType
];
